import React, { Dispatch, SetStateAction } from 'react'
import dayjs from 'dayjs'
import { Need, ResidentNeed } from '@lmc/ts-common'
import { CarePlansPopup } from '../../../../../components/carePlans'
import { TableOLD } from '@lmc/ui-kit'
import { RenderRowCell } from './utils'
import { Spinner } from '../../../../../components/generic'

export type ProfileNeedOption = { name: string; needs: Need[] }

interface Props {
  needs: ResidentNeed[]
  needOptions: Need[]
  carePlanNominative: string
  setProfileNeedDetail: Dispatch<SetStateAction<ResidentNeed | undefined>>
  loading?: boolean
  testId?: string
}

export function ResidentNeedsTable({
  needs,
  carePlanNominative,
  setProfileNeedDetail,
  needOptions,
  loading,
  testId,
}: Props): React.ReactElement {
  if (loading) {
    return (
      <Spinner
        data-testid={
          testId ? `${testId}-needs-table-loading` : 'needs-table-loading'
        }
      />
    )
  }

  return (
    <TableOLD
      data-testid={testId ? `${testId}-needs-table` : 'needs-table'}
      columns={[
        { key: 'need', title: `Need`, cellType: 'custom' },
        { key: 'added', title: `Added`, cellType: 'custom' },
        {
          key: 'info',
          title: `Additional Info`,
          cellType: 'custom',
        },
      ]}
      onRow={(record: { id: string } | unknown) => ({
        onClick: () => {
          setProfileNeedDetail(
            needs.find((need) => need.id === (record as { id: string }).id),
          )
        },
      })}
      rows={needs?.map((residentNeed) => {
        const hasNotes = residentNeed?.notes && residentNeed?.notes !== ''
        const hasCarePlanNotes = !!residentNeed?.carePlans?.length

        return {
          need: {
            renderCell: () => (
              <RenderRowCell classVariable={styles.cellRow}>
                {needOptions.find(
                  (needOption) => needOption.id === residentNeed.need,
                )?.name || '-'}
              </RenderRowCell>
            ),
          },
          key: residentNeed.id,
          id: residentNeed.id,
          added: {
            renderCell: () => (
              <RenderRowCell classVariable={styles.cellRow}>
                {dayjs(residentNeed.addedOn).format('DD-MM-YYYY')}
              </RenderRowCell>
            ),
          },
          info: {
            renderCell: () => (
              <RenderRowCell classVariable={styles.cellRow}>
                {residentNeed?.notes || null}
                {!hasNotes && !hasCarePlanNotes ? '-' : null}
                {hasNotes && hasCarePlanNotes && ', '}
                {!!residentNeed?.carePlans?.length && (
                  <CarePlansPopup
                    riskAssessmentCarePlans={residentNeed?.carePlans}
                    carePlanNominative={carePlanNominative}
                    placement="bottomLeft"
                  />
                )}
              </RenderRowCell>
            ),
          },
        }
      })}
    />
  )
}

const styles = {
  cellRow: {
    display: 'flex',
    cursor: 'pointer',
  },
  logoIcon: {
    width: 26,
    height: 26,
  },
}

export default ResidentNeedsTable
